<div class="page-container">
  <!-- <viz-header title="NRP DASHBOARD" brandLink="http://vizientinc.com">
    <app-header></app-header>
  </viz-header> -->
  <app-header></app-header>
  <viz-container>
    <viz-main-content>
      <router-outlet></router-outlet>
    </viz-main-content>
  </viz-container>
  <viz-footer contactLink="mailto:nrpinfo@vizientinc.com"
              contactDisplay="Contact Us"
              termsLink="https://www.vizientinc.com/privacy-policy-and-legal-notice"
              termsDisplay="Terms & Agreement"
              appTitle="NRP DASHBOARD"
              copyright="Vizient Inc. All Rights Reserved">
  </viz-footer>
</div>
